<template>
  <div :class="`download-app-banner ${visible ? '' : 'download-app-banner--hidden'}`">
    <img src="@/assets/app-icon.png" alt />
    <div>
      <p v-t="'downloadAppBanner.title'" />
      <p v-t="'downloadAppBanner.text'" />
    </div>
    <btn href="https://playkidsapp.page.link/playphone" pink v-t="'downloadAppBanner.CTA'" />
    <span @click="close" />
  </div>
</template>

<script>
import store from 'store'
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'download-app-banner',
  data: () => ({
    visible: false
  }),
  watch: {
    '$route.name': 'setVisibility'
  },
  computed: {
    ...mapState({ isWebView: state => state.window.isWebView }),
    ...mapGetters({ isMobile: 'device/isMobile' }),
    shouldBeVisible() {
      const validRoute = this.$route.name === 'browse' || this.$route.name === 'playlist-group-view'
      const isBannerDismissed = store.get('banner_dismissed')

      return validRoute && !isBannerDismissed && this.isMobile && !this.isWebView
    }
  },
  methods: {
    setVisibility() {
      this.visible = this.shouldBeVisible
    },
    close() {
      store.set('banner_dismissed', true)
      this.visible = false
    }
  },
  created() {
    this.setVisibility()
  }
}
</script>

<style lang="scss" scoped>
.download-app-banner {
  position: fixed;
  bottom: 22px;
  display: flex;
  align-items: center;
  padding: 10px;
  border-radius: 16px;
  background-color: white;
  box-shadow: 0px 4px 18px rgba(92, 31, 153, 0.15);
  width: 300px;
  left: 50%;
  transform: translateX(-50%);
  transition: bottom 0.4s ease-in-out;
  z-index: 1;

  &--hidden {
    bottom: -100%;
  }

  & > img {
    height: 52px;
    width: 52px;
    min-width: 52px;
    margin-right: 10px;
  }

  & > div > p {
    margin: 0;
    line-height: 15px;
    margin-bottom: 4px;
    font: {
      size: 11px;
      weight: normal;
    }

    &:first-child {
      line-height: 16px;
      font: {
        size: 12px;
        weight: 900;
      }
    }
  }

  & > .btn {
    font-size: 12px;
    padding: 0.9rem;
    margin-left: 10px;
  }

  & > span {
    position: absolute;
    top: -6px;
    right: -6px;
    width: 24px;
    height: 24px;

    background: {
      color: #CFDEE6;
      image: url('~@/assets/close-icon.svg');
      size: 12px 12px;
      position: center center;
      repeat: no-repeat;
    }

    border: 2px solid #FFFFFF;
    border-radius: 12px;
    cursor: pointer;
  }

  @media screen and (min-width: 350px) {
    width: 330px;
  }
}
</style>
